/* global angular */
angular.module('ua5App.index.artist')
    .controller('FullscreenCtrl', ['close', 'image', 'scroll', 'embed', '$scope', function(close, image, scroll, embed, $scope) {
        var self = this;
        self.image = image;
        self.embed = embed;
        self.scroll = scroll;
        self.close = function() {
            close();
        };
        $scope.$on('app:escapePressed', function() {
            self.close();
        });
    }])
;
